import React, { useEffect, useState } from "react";
import { Button, Divider, Checkbox, Form, Modal, Radio, Input } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import toast from "react-hot-toast";

const CustomizeCustomProduct = ({
  isOpen,
  onOk,
  onCancel,
  itemData,
  vendorId,
}) => {
  const dispatch = useDispatch();
  const [modifireList, setModifireList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  const getAllModifire = async (vendorId) => {
    dispatch(changeLoader(true));
    try {
      let params = {};
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_CUSTOME_MODIFIRE_LIST + "/" + vendorId,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (apiResponse?.data?.data) {
          let itemList = [];
          for (let item of apiResponse?.data?.data) {
            let name = "";
            for (let itm of item?.modifierGroupLocales) {
              if (itm.languageCode === "en") name = itm.name;
            }
            let option = [];
            for (let itm of item?.modifierGroupItems) {
              console.log("itm", itm?.price);
              let isChecked = false;
              if (itemData.modifier_details) {
                for (let row of itemData.modifier_details) {
                  if (row.product_modifier_id === item.id) {
                    for (let rowData of row.modifier_items) {
                      if (rowData.product_modifier_item_id === itm.id)
                        isChecked = true;
                    }
                  }
                }
              }
              option.push({
                id: itm.id,
                name: itm?.modifierGroupItemLocales[0]?.name,
              //  price: itm?.modifierGroupItem?.price ,
                price:  itm?.price,
                isChecked: isChecked,
              });
            }
            itemList.push({
              id: item.id,
              type: item?.type,
              name: name,
              min: item?.min,
              max: item?.max,
              option: option,
              error: "",
            });
          }
          setModifireList(itemList);
        }
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllModifire(vendorId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemData, vendorId]);

  // Handle radio selection
  const handleRadioChange = (itemId, selectedId) => {
    const updatedList = modifireList.map((item) => {
      if (item.id === itemId) {
        const updatedOptions = item.option.map((opt) => ({
          ...opt,
          isChecked: opt.id === selectedId, // Set true only for selected radio
        }));
        return { ...item, option: updatedOptions, error: "" };
      }
      return item;
    });
    setModifireList(updatedList);
  };

  // Handle checkbox selection
  const handleCheckboxChange = (itemId, optionId, isChecked) => {
    const updatedList = modifireList.map((item) => {
      if (item.id === itemId) {
        const updatedOptions = item.option.map((opt) =>
          opt.id === optionId ? { ...opt, isChecked: isChecked } : opt
        );
        return { ...item, option: updatedOptions, error: "" };
      }
      return item;
    });
    setModifireList(updatedList);
  };

  const handleContinue = () => {
    let checkTokan = false;
    for (let i in modifireList) {
      let row = modifireList[i];
      let tokan = true;
      let count = 0;
      for (let itm of row.option) {
        if (itm.isChecked) {
          tokan = false;
          count = count + 1;
        }
      }
      let errorMsg = "";
      if (row.min > 0 && tokan) {
        errorMsg = `You need to select minimum ${row.min} option`;
      }
      if (row.min > count) {
        errorMsg = `You need to select minimum ${row.min} option`;
      }
      if (row.max < count) {
        errorMsg = `You can select only maximum ${row.max} option`;
      }
      if (errorMsg !== "") {
        checkTokan = true;
        setModifireList((prevList) => {
          let allModifiers = [...prevList];
          let singleModifier = allModifiers[i];
          let updateModifier = {
            ...singleModifier,
            error: errorMsg,
          };
          allModifiers[i] = updateModifier;
          return allModifiers;
        });
      }
    }
    if (checkTokan) return false;

    // set modifier_details
    let modifier_details = [];
    for (let row of modifireList) {
      let token = false;
      let itemDetail = [];
      for (let itm of row.option) {
        if (itm.isChecked) {
          itemDetail.push({ product_modifier_item_id: itm.id });
          token = true;
        }
      }
      if (token) {
        modifier_details.push({
          product_modifier_id: row.id,
          modifier_items: itemDetail,
        });
      }
    }

    let product = null;
    let modifireName = [];
    for (let row of modifireList) {
      let token = false;
      let modifireNames = [];
      for (let opt of row.option) {
        if (opt.isChecked) {
          modifireNames.push(opt.name);
          token = true;
        }
      }

      if (token) {
        modifireName.push({
          modifireItem: modifireNames.join(","),
          modifireName: row.name,
        });
      }
    }
    product = {
      modifireName: modifireName,
      packageingSize: itemData?.product?.packageingSize,
      productImages: itemData?.product?.productImages,
      productName: itemData?.product?.productName,
      productUomName: itemData?.product?.productUomName,
      reference_link: itemData?.product?.reference_link,
      totalAmount: totalAmount,
    };

    let newItemData = {
      custom_cake_images: itemData?.custom_cake_images,
      modifier_details: modifier_details,
      packaging_type_id: itemData?.packaging_type_id,
      item_sensitivity_id: itemData?.item_sensitivity_id,
      product: product,
      product_id: itemData.product_id,
      refference_link: itemData?.refference_link,
      type: itemData.type,
      uom_id: itemData?.uom_id,
      custom_product_price: totalAmount,
    };
    console.log("newItemData", newItemData);
    onOk(newItemData);
  };

  const calculateTotalAmount = () => {
    let amount = 0;
    console.log("modifireList", modifireList);
    for (let item of modifireList) {
      for (let row of item.option) {
        if (row?.isChecked && row.price) amount = amount + row.price;
      }
    }
    console.log("amount", amount);
    setTotalAmount(amount);
  };

  useEffect(() => {
    calculateTotalAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifireList]);

  return (
    <>
      <Modal
        title="Custom Product"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        footer={null}
      >
        <Form
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          {modifireList.length > 0
            ? modifireList.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    <Divider className="bg-[#E5E7EB]" />
                    <div
                      key={index}
                      className="flex justify-between items-center mb-5"
                    >
                      <div className="relative">
                        <h6 className="font-semibold">{item.name}</h6>
                        <p className="text-[#808080]">
                          At least {item.min} min and {item.max} max options are
                          required to choose
                        </p>
                      </div>
                      {item.min > 0 ? (
                        <Button icon={<CheckOutlined />}>Required</Button>
                      ) : null}
                    </div>
                    {item.type === "single" ? (
                      item?.option?.length > 0 ? (
                        <Radio.Group
                          onChange={(e) =>
                            handleRadioChange(item.id, e.target.value)
                          }
                          value={
                            item.option.find((opt) => opt.isChecked)?.id || null
                          }
                          className="w-full"
                        >
                          {item?.option?.map((itm, ind) => (
                            <div key={ind} className="custom-radio-text">
                              <Radio value={itm.id} className="w-full full-w-radio"  >
                                <div className="w-full flex justify-between items-center gap-2">
                                {itm.name}{" "}
                                {itm.price > 0 && (
                                  <span className="font-medium">
                                    SAR {itm.price}
                                  </span>
                                )}
                                </div>
                               
                              </Radio>
                            </div>
                          ))}
                        </Radio.Group>
                      ) : null
                    ) : item?.option?.length > 0 ? (
                      <div className="w-full">
                        {item?.option?.map((itm, ind) => (
                          <div
                            key={ind}
                            className="flex justify-between items-center w-full"
                          >
                            <Checkbox
                              checked={itm.isChecked}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  item.id,
                                  itm.id,
                                  e.target.checked
                                )
                              }
                              className=" w-full full-w-checkbox"
                            >
                              <div className="w-full flex justify-between items-center gap-2">
                              {itm.name}
                              {itm.price > 0 && (
                                <div className="font-medium">
                                  SAR {itm.price}
                                </div>
                              )}
                              </div>
                             
                            </Checkbox>
                          </div>
                        ))}
                      </div>
                    ) : null}
                    {item.error !== "" ? (
                      <span className="text-red-100">{item.error}</span>
                    ) : null}
                  </React.Fragment>
                );
              })
            : null}

          <Divider className="bg-[#E5E7EB]" />
          <div className="flex justify-between items-center">
            {totalAmount > 0 ? (
              <div className="text-[#222222]">
                Total Amount&nbsp;
                <Input
                  type="number"
                  value={totalAmount}
                  onChange={(e) => {
                    const newAmount = parseFloat(e.target.value) || 0;
                    setTotalAmount(newAmount);
                  }}
                  className="w-32 mt-1"
                  prefix="SAR"
                />
              </div>
            ) : null}
            <Button
              type="primary"
              className="h-[39px]"
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CustomizeCustomProduct;
